import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RememberPwaUseResponse extends BackendResponse {}
export interface RememberPwaUseParameters extends NextApiParams {}

export const rememberPwaUse = withNextApi<
  RememberPwaUseResponse,
  RememberPwaUseParameters
>("/metadata/RememberPwaUse", { method: "POST" });
